import { render } from "./AppLayout_3_9.vue?vue&type=template&id=7a144cee&scoped=true"
import script from "./AppLayout_3_9.vue?vue&type=script&lang=js"
export * from "./AppLayout_3_9.vue?vue&type=script&lang=js"

import "./AppLayout_3_9.vue?vue&type=style&index=0&id=7a144cee&scoped=true&lang=css"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a144cee"]])

export default __exports__